import { render } from "./PreventivoVenditaValet.vue?vue&type=template&id=13479be9&scoped=true"
import script from "./PreventivoVenditaValet.vue?vue&type=script&lang=js"
export * from "./PreventivoVenditaValet.vue?vue&type=script&lang=js"

import "./PreventivoVenditaValet.vue?vue&type=style&index=0&id=13479be9&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13479be9"]])

export default __exports__